import { create } from "zustand";

type LocationParam = {
  id: string;
  name: string;
  color?: string | null;
};

export type SetHoveredListLocation = (args: LocationParam | undefined) => void;

export interface HoveredListLocationState {
  hoveredListLocation: LocationParam | undefined;
  setHoveredListLocation: SetHoveredListLocation;
}

export const useHoveredListLocationStore = create<HoveredListLocationState>(
  (set) => ({
    hoveredListLocation: undefined,
    setHoveredListLocation: (hoveredListLocation) => {
      set({ hoveredListLocation });
    },
  }),
);
